/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "@tanstack/react-query";
import {
  getActivityLog,
  getFlowDashboard,
  getLocationDashboard,
} from "./mutations";

export const useGetFlowDashboard = (payload: any, view: string, refetchInterval?: number | false) => {
  return useQuery({
    queryKey: ["getFlowDashboard", payload],
    queryFn: getFlowDashboard,
    enabled: view === "Flow" ? false : true,
    refetchInterval: view === "Location" ? refetchInterval : false,
  });
};

export const useGetLocationDashboard = (payload: any, view: string, refetchInterval?: number | false) => {
  return useQuery({
    queryKey: ["getLocationDashboard", payload],
    queryFn: getLocationDashboard,
    enabled: view === "Location" ? false : true,
    refetchInterval: view === "Flow" ? refetchInterval : false,
  });
};

export const useGetActivityLog = (payload: any) => {
  return useQuery({
    queryKey: ["getActivityLog", payload],
    queryFn: getActivityLog,
  });
};
